import { Spinner } from '@material-tailwind/react';
import { lazy, Suspense } from 'react';
import { createBrowserRouter } from 'react-router-dom';
import communityRouter from '@/router/communityRouter.jsx';
import loveRouter from '@/router/loveRouter.jsx';
import daycareRouter from '@/router/daycareRouter.jsx';
import hopeRouter from '@/router/hopeRouter.jsx';
import transportRouter from '@/router/transportRouter.jsx';
import kidneyRouter from '@/router/kidneyRouter.jsx';
import associationRouter from '@/router/associationRouter.jsx';
import TransportCenter from '@/pages/TransportCenter';
import ScrollToTheTop from '@/components/ScrollToTheTop';
import LoadingSpinner from '@/components/common/LoadingSpinner';

const CommonLayout = lazy(() => import('../layout/CommonLayout.jsx'));
const MainPage = lazy(() => import('@/pages/MainPage'));
const Test = lazy(() => import('@pages/TestPage.jsx'));
const LoginPage = lazy(() => import('@pages/admin/LoginPage.jsx'));
const SignupPage = lazy(() => import('@pages/admin/SignupPage.jsx'));
const ChangePasswordPage = lazy(() =>
  import('@pages/admin/ChangePasswordPage.jsx')
);
const EditProfilePage = lazy(() => import('@pages/admin/EditProfilePage.jsx'));
const NoticePage = lazy(() => import('@/pages/community/notice/NoticePage'));
const NewsPage = lazy(() => import('@/pages/community/news/NewsPage'));
const ScheduleDetailPage = lazy(() =>
  import('@/pages/community/programs/ScheduleDetailPage')
);
const OverviewPage = lazy(() => import('@/pages/kidney/OverviewPage'));

const Loading = () => (
  <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-70 z-50">
    <Spinner className="h-12 w-12 text-white" />
    <p className="text-white mt-4">Loading, please wait...</p>
  </div>
);

const root = createBrowserRouter([
  {
    path: '/',
    element: (
      <Suspense fallback={<LoadingSpinner />}>
        <CommonLayout />
      </Suspense>
    ),
    children: [
      {
        index: true,
        element: (
          <Suspense fallback={<LoadingSpinner />}>
            <MainPage />
          </Suspense>
        ),
      },
      { path: 'test', element: <Test /> },
      { path: 'admin/login', element: <LoginPage /> },
      { path: 'admin/signup', element: <SignupPage /> },
      { path: 'association/*', children: associationRouter() },
      { path: 'kidney/*', children: kidneyRouter() },
      { path: 'transport/*', children: transportRouter() },
      { path: 'hope/*', children: hopeRouter() },
      { path: 'daycare/*', children: daycareRouter() },
      { path: 'community/*', children: communityRouter() },
      { path: 'love/*', children: loveRouter() },
      { path: 'admin/change-password', element: <ChangePasswordPage /> },
      { path: 'admin/edit-profile', element: <EditProfilePage /> },
      {
        path: 'community/notices',
        element: (
          <Suspense fallback={<LoadingSpinner />}>
            <NoticePage />
          </Suspense>
        ),
      },
    ],
  },
]);
export default root;
